import './Lantern.less';

const Lantern = () => <div className={`bri-Lantern`}></div>;

export default Lantern;
